import { useModel } from '@umijs/max';
import {
  formatDateTime,
  fromPickerDisplay,
  nowInTimezone,
  normalizeRangeForApi,
  pickerValueToUtcIso,
  toPickerDisplay,
  type TimezoneMode,
} from '@/utils/timezone';

export function useTimezone() {
  const { mode, setMode } = useModel('timezone');

  return {
    mode,
    setMode,
    formatDateTime: (value: unknown, format?: string) =>
      formatDateTime(value, format, mode),
    toPickerDisplay: (value: unknown) => toPickerDisplay(value, mode),
    fromPickerDisplay: (value: Parameters<typeof fromPickerDisplay>[0]) =>
      fromPickerDisplay(value, mode),
    pickerValueToUtcIso: (value: Parameters<typeof pickerValueToUtcIso>[0]) =>
      pickerValueToUtcIso(value, mode),
    normalizeRangeForApi: (range: unknown) => normalizeRangeForApi(range, mode),
    now: () => nowInTimezone(mode),
  };
}

export type { TimezoneMode };
